<template>
	<div>
		<div v-if="pdf_buffer">
			<p v-if="showFileName">{{ name_file }}</p>
			<div>
				<span @click="currentPage--" v-if="currentPage > 1">&lt; </span
				>{{ currentPage }} / {{ pageCount }} page<span v-if="pageCount > 1">s</span>
				<span @click="currentPage++" v-if="currentPage < pageCount">
					&gt;</span
				>
				<br />
				<span> rotation <b-select style="width:100px" v-model="rotate" :options="[0,90,180,270]" /></span>
			</div>

			<b-button @click="reset">Recadrer la vue</b-button>

			<div ref="panzoomElem">
				<panZoom
					selector=".movable"
					style="border: 1px solid; overflow: hidden"
					:options="{
						initialZoom: 1,
						bounds: false,
					}"
					@init="onInit">
					<div
						style="height: 500px; width: 2000px"								
						@mousemove="handler_move($event)"
						@contextmenu.prevent>
						<div class="movable">
							<vue-pdf-embed 
								:style="'transform: rotate(' + rotate + 'deg);'"
								class="vue-pdf-embed"
								:ref="'pdf' + id"
								:id="'pdf' + id"
								:page="currentPage"
								@rendered="handleDocumentRender"
								:source="pdf_buffer"
								:showAllPages="false" />
						</div>
					</div>
				</panZoom>

				<b-button v-if="showDownload" variant="link" @click="dowload">Télécharger</b-button>
			</div>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import { renderAsync, defaultOptions } from 'docx-preview'
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

	import treatments from "../services/treatments.js";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import utils from "../services/utils.js";
	import document_service from "../services/document.js";

	export default {
		name: "view_file_zoom",
		components: {
			VuePdfEmbed
		},
		props: {
			uid_element: {
				default: null
			},
			project: {
				default: () => {},
			},
			showFileName: {
				type: Boolean,
				default: true,
				required: false,
			},
			data: {
				default: () => null,
			},
			name: {
				default: () => null,
			},
			details: {
				default: () => null,
			},
			file: {
				default: () => null,
			},
			showDownload: {
				type: Boolean,
				default: true,
				required: false,
			},
			getDownload: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				id: uniqueId(""),
				data_file: null,
				pdf_buffer: null,
				editor: null,
				currentPage: 1,
				pageCount: 0,
				name_file: "",
				panzoomInstance: null,
				image_width: 0,
				image_height: 0,
				rotate: 0,
				x: 0,
				y: 0
			};
		},
		watch: {
			data: {
				deep: true,
				handler: async function () {
					//console.log("viewfile data modif")
					if (this.data)
						this.viewFile(this.data, this.name, this.details, this.file)
				}
			}
		},
		methods: {
			handler_move: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.x = Math.round(left);
				this.y = Math.round(top);

				//console.log(this.x, this.y)
			},
			handleDocumentRender () {
				//console.log(this.$refs)
				this.pageCount = this.$refs['pdf' + this.id].pageCount;
			},
			async dowload() {
				if (typeof this.data_file == "string")
					await treatments.getFileAlyx(
						this.data_file,
						true,
						"arraybuffer",
						this.name_file
					);
				else
					await treatments.getFile(
						this.data_file.item.id,
						this.data_file.item.name,
						true,
						"arraybuffer"
					);
				this.$emit("download");
			},
			viewFile: async function (data, name, details, file) {
				var self = this;
				this.pdf_buffer = "";
				this.tabulator_data = null;
				this.xml = null;
				this.html = null;
				this.image = null;

				if (!name && data)
					name = data.substring(data.lastIndexOf('/') + 1);

				this.data_file = data;
				this.name_file = name;

				//console.log(data)
				//console.log(name)

				if (name.endsWith(".pdf")) {
					if (typeof data == "string")
						var results_file = await treatments.getFileAlyx(
							data,
							false,
							"arraybuffer"
						);
					else
						var results_file = await treatments.getFile(
							data.item.id,
							data.item.name,
							false,
							"arraybuffer"
						);
					this.pdf_buffer = new Uint8Array(results_file);
				}
				else if (this.getDownload)
				{
					this.dowload();
				}
			},
			reset() {
				this.panzoomInstance.zoomAbs(0, 0, 1);
				this.panzoomInstance.moveTo(0, 0);
			},
			onInit: function (panzoomInstance, id) {
				this.panzoomInstance = panzoomInstance;
				//this.panzoomInstance.zoomTo(0, 0, 2);
			},
		},
		async mounted() {
			if (this.uid_element)
			{
				var document = await document_service.getInfoFile(this.uid_element);
				this.viewFile(document.url, document.libelle)
				//console.log(document)
			}
			if (this.data)
				this.viewFile(this.data, this.name, this.details, this.file)
		}
	};
</script>

<style>
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
</style>